import React from 'react';
import Typography from '@mui/material/Typography';
import { useReservation } from "./ReservationContext";
import Grid from '@mui/material/Grid2';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import ManIcon from '@mui/icons-material/Man';
import ChildCareIcon from '@mui/icons-material/ChildCare';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './ColorTheme';
import { useMatomo } from '@datapunt/matomo-tracker-react'

const ReservationStep3 = () => {
   const { reservationState, setReservationState } = useReservation();
   const { selectedDateTime, needsBabyChair, slides, name, contact, additionalInfo } = reservationState;
   const { trackPageView } = useMatomo()

   // Track page view
   React.useEffect(() => {
      trackPageView({ documentTitle: 'Reservation Step 3' })
   }, [])

   const formattedDateTime = selectedDateTime
      ? selectedDateTime.format('DD.MM.YYYY HH:mm')
      : '';

   return (
      <ThemeProvider theme={theme}>
         <Grid container spacing={2} className={"padded"} sx={{ justifyContent: "center", width: "100%", margin: "0 0 0 0" }}>
            <Grid xs={12}>
               <Typography gutterBottom>
                  Hier siehst du nochmal eine Zusammenfassung deiner Reservierung.
                  Klicke unten auf "Reservieren!" um Deine Reservierung
                  zu fixieren.
               </Typography>
            </Grid>

            {/* Datum und Uhrzeit */}
            <Grid xs={12} sx={{ width: "100%" }} >
               <Typography variant="h6">Datum und Uhrzeit</Typography>
               <Typography>{formattedDateTime}</Typography>
               <Divider sx={{ borderBottomWidth: 1, marginTop: 1 }} />
            </Grid>

            {/* Tabelle */}
            {!!slides.filter((entry) => entry.adults>0||entry.children>0).length &&
               <Grid xs={12} sx={{ width: "100%" }}>
                  <Typography variant="h6">Deine Auswahl</Typography>
                  <Table>
                     <TableBody>
                        {slides
                           .filter(
                              (entry) => entry.adults > 0 || entry.children > 0
                           )
                           .map((entry, index) => (
                              <TableRow key={index} sx={{ '& td, & th': { border: 0 } }}>
                                 <TableCell style={{ width: '40%', textAlign: 'center' }}>{entry.title}</TableCell>
                                 <TableCell style={{ textAlign: 'center' }}>
                                    {Array(entry.adults)
                                       .fill(null)
                                       .map((_, i) => (
                                          <ManIcon key={i} />
                                       ))}
                                    {Array(entry.children)
                                       .fill(null)
                                       .map((_, i) => (
                                          <ChildCareIcon key={i} />
                                       ))}
                                 </TableCell>
                              </TableRow>
                           ))}
                     </TableBody>
                  </Table>
                  <Divider sx={{ borderBottomWidth: 1, marginTop: 0 }} />
               </Grid>
            }

            {/* Additional */}
            <Grid xs={12} sx={{ width: "100%" }}>
               <Typography variant="h6">Weitere Angaben</Typography>
               {needsBabyChair &&
                  <>
                     <Typography>Ich brauche einen Babystuhl</Typography>
                     <Divider sx={{ borderBottomWidth: 1, margin: 1 }} />
                  </>
               }
               <TextField
                  label="Zusätzliche Informationen"
                  variant="outlined"
                  fullWidth
                  color='baerendark'
                  multiline
                  rows={3}
                  value={additionalInfo}
                  placeholder={"Allergien, Unverträglichkeiten, besondere Wünsche - wir kümmern uns darum!"}
                  onChange={(e) => {
                     setReservationState((prevState) => ({
                        ...prevState,
                        additionalInfo: e.target.value,
                     }));
                  }
                  }
                  margin="normal"
               />
               <TextField
                  required
                  error={!name}
                  label="Name"
                  variant="outlined"
                  color='baerendark'
                  value={name}
                  fullWidth
                  onChange={(e) =>
                     setReservationState((prevState) => ({
                        ...prevState,
                        name: e.target.value,
                     }))
                  }
                  margin="normal"
               />
               <TextField
                  required
                  error={!contact}
                  label="E-Mail oder Telefonnummer"
                  variant="outlined"
                  value={contact}
                  color='baerendark'
                  fullWidth
                  onChange={(e) =>
                     setReservationState((prevState) => ({
                        ...prevState,
                        contact: e.target.value,
                     }))
                  }
                  margin="normal"
               />
            </Grid>

            {/* Checkbox */}
            <Grid xs={12}>
               <FormGroup>
                  <FormControlLabel
                     control={
                        <Checkbox
                           defaultChecked
                           color='baerendark'
                           onChange={(e) =>
                              setReservationState((prevState) => ({
                                 ...prevState,
                                 consent: e.target.checked,
                              }))
                           }
                        />}
                     label="Ich willige ein, dass meine angegebenen Daten zum Zweck der Reservierung gespeichert werden." />
                  <p></p>
               </FormGroup>
            </Grid>
         </Grid>
      </ThemeProvider>
   );
};

export default ReservationStep3;